import { OnInit, AfterViewInit, Component, ElementRef, Renderer2, RendererFactory2, ChangeDetectorRef, ViewChild } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';

import { MatDialog } from '@angular/material/dialog';

//! changed Map to olMap so ts/js 'Map' can be used...
import olMap from 'ol/Map';
import Interaction from 'ol/interaction/Interaction';
import Collection from 'ol/Collection';
import Overlay from 'ol/Overlay';
import { unByKey } from 'ol/Observable';
import { Vector as VectorLayer } from 'ol/layer';
import VectorSource from 'ol/source/Vector';
import { Polygon, LineString } from 'ol/geom';
import { Draw, Modify, Snap } from 'ol/interaction';
import { Circle as CircleStyle, Icon, Circle, Fill, Stroke, Style, Text } from 'ol/style';
import Point from 'ol/geom/Point';
import Feature from 'ol/Feature';
import { getArea, getLength } from 'ol/sphere';
import { click as clickCondition } from 'ol/events/condition';
import { toStringXY } from 'ol/coordinate';

import { OlLayerService } from '../../../services/ol/ol-layer.service';
import { BrowserSnifferService } from "../../../services/browser-sniffer.service";
import { MapService } from '../../../services/map.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { OlTooltip } from '../../../models/ol-tooltip';
import { SendMapRemarkDialogComponent } from '../send-map-remark-dialog/send-map-remark-dialog.component';
import { Subscription } from 'rxjs';
import * as olHas from 'ol/has';

import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { BackEventService } from '@tt-lib/services/back-event.service';

export interface ToolTip { placeMarker: boolean, placeMarkerTouch: boolean, confirmMarker: boolean, lockMarker: boolean, lockMarkerTouch: boolean, readyToSend: boolean };


@Component({
  selector: 'tt-send-map-remark-panel',
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonToggleModule,
    TranslateModule,
    MatCheckboxModule,
    MatDividerModule
  ],
  templateUrl: './send-map-remark-panel.component.html',
  styleUrls: ['./send-map-remark-panel.component.scss'],
  standalone: true
})

export class SendMapRemarkPanelComponent implements OnInit {

  toolTip: ToolTip = {
    placeMarker: false,
    placeMarkerTouch: false,
    confirmMarker: false,
    lockMarker: false,
    lockMarkerTouch: false,
    readyToSend: false
  };
  formData = {
    firstName: '',
    lastName: '',
    email: '',
    message: '',
    keepInformed: true,
    poi: undefined,
    validateOnOpen: false
  }
  private styles: Map<string, Style> = new Map();
  private overlayCanvas: HTMLCanvasElement;
  private overlayCtx: CanvasRenderingContext2D;
  private canvas: HTMLCanvasElement;
  private ctx: CanvasRenderingContext2D;
  private renderer: Renderer2;
  private olViewportElement: HTMLElement;
  private mapWidth: number;
  private mapHeight: number;
  private safeTop: number;

  private map: olMap;
  private draw: Draw;
  private modify: Modify;
  private drawLayer: any;//VectorLayer;

  private interactions: Collection<Interaction>;

  public remarksTooltipElement: HTMLElement;
  public remarksTooltip: OlTooltip;
  private poi: any;//Collection<any>;
  private markerFeature: Feature;
  private tooltipmaplistener;
  private subscriptions: Subscription = new Subscription();

  //? used
  public isMapRemarksActive: boolean;

  private messageType: string;
  public canCommentMap: boolean = true;
  public hidden: boolean = false;

  public csrf: string = "";
  @ViewChild('elevationProfile') elevationProfile?: ElementRef<HTMLElement>;

  constructor(
    public browserSniffer: BrowserSnifferService,
    public translateService: TranslateService,
    private bottomSheetRef: MatBottomSheetRef<SendMapRemarkPanelComponent>,
    private changeDetectorRef: ChangeDetectorRef,
    private rendererFactory: RendererFactory2,
    private elementRef: ElementRef,
    public mapService: MapService,
    private olLayerService: OlLayerService,
    public dialog: MatDialog,
    private backEventService: BackEventService
  ) {
    // Get an instance of Angular's Renderer2
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  ngOnInit(): void {
    this.setMarkerStyles();
    //! todo
    //csrf
    this.olViewportElement = document.querySelector<HTMLElement>('.ol-viewport')!;
    // setTimeout((_) => {
    // this.openDialog();
    // }, 1050);
    this.safeTop = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--safe-top')) || 0;

  }

  ngAfterViewInit() {
  }

  ngAfterContentInit() {// ! tester si peut être mis dans afterViewInit    
    this.subscriptions.add(
      this.bottomSheetRef.afterDismissed().subscribe(() => {
        this.close();
      })
    )
    this.map = this.mapService.getMap();
    //touch
    if (this.browserSniffer.isTouchDevice) {
      this.addMapRemarksInteractionTouch();
      this.setToolTip('placeMarkerTouch');
      this.refresh();
      //when measure bottomsheet was open, wait a bit till it had time to close
      setTimeout(() => {
        this.disableNoMapInteractions();
      }, 600)
    }
    else {
      this.drawLayer = this.olLayerService.getLayerById("drawLayer");
      this.addMapRemarksInteractionDesktop();
      this.setToolTip('placeMarker');
      this.refresh();
    }    
    this.mapWidth = this.map.getSize()[0];
    this.mapHeight = this.map.getSize()[1];
  }

  public close(): void {
    if (this.browserSniffer.isTouchDevice) {
      this.removeInteractionsTouch();
    } else {
      this.removeInteractionsDesktop();
    }
    this.bottomSheetRef.dismiss();
    document.getElementById("baselayerSelectorButtonContainer").removeEventListener("click", this.close);
    this.subscriptions.unsubscribe();
  }

  //dialog with form
  openDialog() {
    const dialogRef = this.dialog.open(SendMapRemarkDialogComponent, {
      closeOnNavigation: true,
      panelClass: 'remark-dialog',
      //backdropClass: 'transparent-backdrop',
      data: {
        firstName: this.formData.firstName || "",
        lastName: this.formData.lastName || "",
        email: this.formData.email || "",
        message: this.formData.message || '',
        keepInformed: this.formData.keepInformed,
        bottomsheet: this.bottomSheetRef,
        poi: this.poi,
        validateOnOpen: this.formData.validateOnOpen || false
      }
    });

    this.subscriptions.add(
      dialogRef.afterClosed().subscribe(formData => {
        //case backdropclick
        // if (!formData) {
        //   this.formData = dialogRef.componentInstance.data;
        // } else {
        this.formData = formData[0];
        this.formData.validateOnOpen = formData[1];
        // }
      })
    );

    this.backEventService.registerOpenedWindow({windowName: 'SendMapRemarkDialogComponent', isAutoCloseableWindow: true});
  }

  private disableNoMapInteractions() {
    this.renderer.setAttribute(document.querySelector<HTMLElement>('.tt-header'), 'inert', '');
     if (this.elevationProfile) {this.renderer.setAttribute(this.elevationProfile, 'inert', ''); }
    Array.from(document.getElementsByClassName('map-control-button')).forEach(element => {
      this.renderer.setStyle(element, 'pointer-events', 'none');
    });
    if (!this.browserSniffer.isPhone()) {
      if (document.getElementsByTagName('body')[0].classList.contains('trace-drawer-open')) {
        this.renderer.setAttribute(document.querySelector<HTMLElement>('.tt-trace-drawer'), 'inert', '');
      };
      if (document.getElementsByTagName('body')[0].classList.contains('legend-drawer-open')) {
        this.renderer.setAttribute(document.querySelector<HTMLElement>('.tt-legend-drawer'), 'inert', '');
      };
    }
  }
  private enableNoMapInteractions() {
    this.renderer.removeAttribute(document.querySelector<HTMLElement>('.tt-header'), 'inert', '');
    if (this.elevationProfile) { this.renderer.removeAttribute(this.elevationProfile, 'inert', ''); }
    Array.from(document.getElementsByClassName('map-control-button')).forEach(element => {
      this.renderer.removeStyle(element, 'pointer-events');
    });
    if (!this.browserSniffer.isPhone()) {
      if (document.getElementsByTagName('body')[0].classList.contains('trace-drawer-open')) {
        this.renderer.removeAttribute(document.querySelector<HTMLElement>('.tt-trace-drawer'), 'inert', '');
      };
      if (document.getElementsByTagName('body')[0].classList.contains('legend-drawer-open')) {
        this.renderer.removeAttribute(document.querySelector<HTMLElement>('.tt-legend-drawer'), 'inert', '');
      };
    }
  }

  /* touch 1 */
  private addMapRemarksInteractionTouch() {
    this.isMapRemarksActive = true;

    //close email form should it be open
    // this.closeRemarksSelect();
    // if (this.isEmailFormOpen) {
    //   this.closeEmailForm();
    // }
    // if (this.isMapRemarksActive) {
    //  this.removeMapRemarksInteraction();
    //   return;
    // }   
    if (!document.getElementById('overlayCanvas')) {
      this.createOverlayCanvas();
    }
    this.addOverlayCanvasMarker();
  }

  /* touch 2 */
  public lockPointTouch() {
    this.setToolTip('lockMarkerTouch');
    this.refresh();
    this.lockOverlayCanvasMarker();
    //disable mapinteractions
    this.interactions = this.map.getInteractions();
    this.setMapInteractions(false);
    let coords = toStringXY(this.map.getView().getCenter(), 2);
    this.poi = coords.split(',', 2);
    this.poi.push(this.map.getView().getZoom());
  };

  public unlockPointTouch() {
    this.setToolTip('placeMarkerTouch');
    this.refresh();
    this.overlayCtx.clearRect(0, 0, this.ctx.canvas.width / olHas.DEVICE_PIXEL_RATIO, this.ctx.canvas.height / olHas.DEVICE_PIXEL_RATIO);
    //enable mapinteractions
    this.setMapInteractions(true);
    this.addMapRemarksInteractionTouch();
  }

  private addMapRemarksInteractionDesktop() {
    //close email form should it be open
    // closeRemarksSelect();
    // if (self.isEmailFormOpen) {
    //   self.closeEmailForm();
    // }
    // if (self.isMapRemarksActive) {
    //   removeMapRemarksInteraction();
    //   return;
    //!used?
    this.isMapRemarksActive = true;

    this.draw = this.createDrawInteraction();
    this.map.addInteraction(this.draw);

    this.modify = this.createModifyInteraction();

    this.setToolTip('placeMarker');
    this.refresh();

  }

  private removeInteractionsDesktop() {
    this.map.removeInteraction(this.draw);
    this.map.removeInteraction(this.modify);
    unByKey(this.tooltipmaplistener);
    this.drawLayer.getSource().clear();
    this.remarksTooltip.deactivate();
    if (this.interactions) {
      this.setMapInteractions(true);
    }
    if (this.overlayCanvas) {
      this.overlayCanvas.remove();
    };
    // this.subscriptions.unsubscribe();
  }

  private createDrawInteraction() {
    const draw = new Draw({
      source: this.drawLayer.getSource(),
      style: this.styles.get('movePointStyle'),
      type: 'Point'
    });
    draw.set('active', true)
    //moving  tooltip on marker
    this.addMarkerTooltip();
    draw.on('drawstart',
      (evt) => {
        this.markerFeature = evt.feature;
      });
    // document.addEventListener("keyup", escapeKey);
    draw.on('drawend',
      (evt) => {
        // document.removeEventListener("keyup", this.escapeKey);
        this.setToolTip('confirmMarker');
        this.refresh();
        this.remarksTooltip.deactivate();
        this.markerFeature.setStyle(this.styles.get('placedPointStyle'));
        unByKey(this.tooltipmaplistener);
        this.remarksTooltip.deactivate();
        setTimeout(
          () => {
            this.draw.setActive(false);
            this.modify.set('active', true);
          }, 0);
        this.map.addInteraction(this.modify);
      });
    return draw;
  }

  private createModifyInteraction() {
    const modify = new Modify({
      source: this.drawLayer.getSource(),
      style: this.styles.get('movePointStyle'),
      pixelTolerance: this.mapService.searchPixelTolerance
    });
    modify.set('active', false);
    modify.on('modifystart',
      () => {
        //  this.map.removeOverlay(this.remarksTooltip);
        this.addMarkerTooltip();
      });
    modify.on('modifyend',
      () => {
        //this.map.removeOverlay(this.remarksTooltip);
        this.remarksTooltip.deactivate();
        unByKey(this.tooltipmaplistener);
      })
    return modify;
  };

  private addOverlayCanvasBackground() {
    this.canvas = document.getElementsByTagName('canvas')[0];
    // this.canvas = document.getElementById('overlayCanvas');
    this.ctx = document.getElementsByTagName('canvas')[0].getContext('2d');
    this.overlayCanvas = this.renderer.createElement('canvas');
    this.renderer.setProperty(this.overlayCanvas, 'id', 'overlayCanvasBackground');
    this.renderer.setProperty(this.overlayCanvas, 'style', 'position:fixed;top:0px;left:0px;z-index:99');
    // this.renderer.setProperty(this.overlayCanvas, 'width', this.ctx.canvas.width / olHas.DEVICE_PIXEL_RATIO );//+ 260
    this.renderer.setProperty(this.overlayCanvas, 'width', this.mapWidth + 360);//window.innerWidth)
    // this.renderer.setProperty(this.overlayCanvas, 'height', this.ctx.canvas.height / olHas.DEVICE_PIXEL_RATIO );//+ 18
    this.renderer.setProperty(this.overlayCanvas, 'height', this.mapHeight); //window.innerHeight)
    // this.renderer.appendChild(document.getElementsByClassName('ol-viewport')[0], this.overlayCanvas);
    const elm = document.querySelector<HTMLElement>('.ol-viewport')!;
    elm.style.overflow = "visible";
    // to avoid layer position problems with fixed elements, append to tt-map  
    this.renderer.appendChild(document.getElementsByTagName('tt-map')[0], this.overlayCanvas);
    // like prepend
    // this.renderer.insertBefore(
    //   document.getElementsByClassName('ol-viewport')[0],
    //   this.overlayCanvas,
    //   document.getElementsByClassName('ol-layers')[0]
    // );
    this.overlayCtx = this.overlayCanvas.getContext('2d');
    this.overlayCtx.clearRect(0, 0, this.mapWidth + 260, this.mapHeight);
    // this.overlayCtx.clearRect(0, 0, this.ctx.canvas.width / olHas.DEVICE_PIXEL_RATIO + 260, this.ctx.canvas.height / olHas.DEVICE_PIXEL_RATIO);
    this.overlayCtx.fillStyle = 'rgba(51, 51, 51, 0.2)';
    this.overlayCtx.fillRect(0, 0, this.mapWidth + 260, this.mapHeight);
    // this.overlayCtx.fillRect(0, 0, this.ctx.canvas.width / olHas.DEVICE_PIXEL_RATIO + 260, this.ctx.canvas.height / olHas.DEVICE_PIXEL_RATIO);
    this.overlayCtx.fill();
  }
  url
  public lockPoint() {
    this.setToolTip('lockMarker');
    //center map to point
    var duration = 500;
    this.map.getView().animate({
      center: (<Point>this.markerFeature.getGeometry()).getCoordinates(),
      duration: duration
    },
      () => {
        this.addOverlayCanvasBackground();
        // this.map.removeInteraction(modify);
        this.modify.setActive(false);
        this.markerFeature.setStyle(this.styles.get('lockedPointStyle'));
        this.interactions = this.map.getInteractions();
        //disable mapinteractions
        this.setMapInteractions(false);
        let coords = toStringXY(this.map.getView().getCenter(), 2).trim();
        this.poi = coords.split(',', 2);
        this.poi.push(this.map.getView().getZoom());
      }
    );
  };

  public unlockPoint() {
    if (this.overlayCanvas) {
      this.overlayCanvas.remove();
    };
    this.setMapInteractions(true);
    this.markerFeature.setStyle(this.styles.get('placedPointStyle'));
    // this.modify.setActive(false);
    this.draw.setActive(false);
    this.setToolTip('confirmMarker');
  };

  private addMarkerTooltip() {
    if (this.remarksTooltip == undefined) {
      this.createMapRemarksTooltip();
    }
    this.remarksTooltip.activate();
    let tooltipCoord;
    this.tooltipmaplistener = this.map.on('pointermove',
      (evt) => {
        tooltipCoord = evt.coordinate;
        this.remarksTooltip.setPosition(tooltipCoord);
      }
    );
    // this.map.addOverlay(this.remarksTooltip);
  }

  private createMapRemarksTooltip() {
    this.remarksTooltipElement = this.renderer.createElement('div');
    this.renderer.addClass(this.remarksTooltipElement, 'tooltip-measure');
    this.renderer.addClass(this.remarksTooltipElement, 'tooltip-draw');
    // this.renderer.setProperty(this.remarksTooltipElement, 'class', 'tooltip-draw tooltip-measure');
    this.renderer.setProperty(this.remarksTooltipElement, 'id', 'remarksTooltip');
    this.renderer.appendChild(this.elementRef.nativeElement, this.remarksTooltipElement);
    this.remarksTooltip = new OlTooltip(this.map, 'remarksTooltip');// tooltip-measure//tooltip-draw
    this.remarksTooltip.setOffset([0, -50]);
    this.remarksTooltip.setPositioning('bottom-center');
    this.translateService.get('send-remark.about_map.help.marker').subscribe((translation: string) => {
      this.remarksTooltip.setText(translation);
    });
  }

  escapeKey(evt) {
    // if (evt && (evt.keyCode === 27)) {
    //     //removeMapRemarksInteraction();
    //     //closeRemarksSelect();
    //     document.removeEventListener("keyup", escapeKey);
    //     //$rootScope.$digest();
    // }
  }

  /* 3 */
  public readyToSend() {
    this.setFullscreen();
    setTimeout(() => {
      this.setToolTip('readyToSend');
      this.refresh();
    }, 250)
  }

  public backToLockedPoint() {
    this.unSetFullscreen();
    this.setToolTip('lockMarkerTouch');
    this.refresh();
  }

  private removeInteractionsTouch() {
    this.isMapRemarksActive = false;
    if (this.overlayCanvas) {
      this.overlayCanvas.remove();
      //window.removeEventListener('resize', redraw);
    }
    if (this.interactions) {
      this.setMapInteractions(true);
    }
    this.enableNoMapInteractions();
  }

  private setMapInteractions(bool: boolean) {
    this.interactions.forEach(
      function (interaction, i) {
        interaction.setActive(bool);
      }
    );
  }

  private lockOverlayCanvasMarker() {
    const viewportTop = this.olViewportElement.getBoundingClientRect().top;
    //overlayCanvas.remove();
    this.overlayCtx.clearRect(0, 0, this.mapWidth + 366, this.mapHeight + this.safeTop + 250);
    this.overlayCtx.fillStyle = 'rgba(0, 0, 0, 0.3)';
    this.overlayCtx.fillRect(0, 0, this.mapWidth + 366, this.mapHeight + this.safeTop + 250);
    this.overlayCtx.fill();
    //circle  
    this.overlayCtx.strokeStyle = 'rgba(224, 190, 12, 1)';
    this.overlayCtx.fillStyle = 'rgba(224, 190, 12, 0.3)';
    this.overlayCtx.lineWidth = 2;
    this.overlayCtx.beginPath();
    this.overlayCtx.arc(this.mapWidth / 2, (this.mapHeight / 2) + viewportTop, 12, 0, 2 * Math.PI);
    this.overlayCtx.stroke();
    this.overlayCtx.fill();
    //marker symbol 
    this.overlayCtx.fillStyle = 'rgba(0, 25, 214, 1.0)';
    this.overlayCtx.font = '28px "NGI-IGN_ICONS"';
    this.overlayCtx.strokeStyle = 'rgba(255, 255, 255, 1)';
    this.overlayCtx.lineWidth = 5;
    this.overlayCtx.strokeText('\ue062', (this.mapWidth / 2) - 14, (this.mapHeight / 2) - 9 + viewportTop);
    this.overlayCtx.fillText('\ue062', (this.mapWidth / 2) - 14, (this.mapHeight / 2) - 9 + viewportTop);
    this.overlayCtx.save();
  }

  private createOverlayCanvas() {
      this.mapWidth = this.map.getSize()[0];
    this.mapHeight = this.map.getSize()[1];
    this.canvas = document.getElementsByTagName('canvas')[0];
    this.ctx = document.getElementsByTagName('canvas')[0].getContext('2d');
    this.overlayCanvas = this.renderer.createElement('canvas');
    this.renderer.setProperty(this.overlayCanvas, 'id', 'overlayCanvas');
    this.renderer.setProperty(this.overlayCanvas, 'style', 'position:fixed;top:0px;z-index:99;pointer-events:none');
    this.renderer.setProperty(this.overlayCanvas, 'width', this.mapWidth + 366);//window.innerWidth)
    // this.renderer.setProperty(this.overlayCanvas, 'width', this.ctx.canvas.width / olHas.DEVICE_PIXEL_RATIO);
    this.renderer.setProperty(this.overlayCanvas, 'height', this.mapHeight + this.safeTop + 250);// + 18 //window.innerHeight
    // this.renderer.setProperty(this.overlayCanvas, 'height', this.ctx.canvas.height / olHas.DEVICE_PIXEL_RATIO);
    // this.renderer.appendChild(document.getElementsByClassName('ol-viewport')[0], this.overlayCanvas);

    this.olViewportElement.style.overflow = "visible";

    // to avoid layer position problems with fixed elements, append to tt-map  
    this.renderer.appendChild(document.getElementsByTagName('tt-map')[0], this.overlayCanvas);
    // like prepend
    // this.renderer.insertBefore(
    //   document.getElementsByClassName('ol-viewport')[0],
    //   this.overlayCanvas,
    //   document.getElementsByClassName('ol-layers')[0]
    // );
    this.overlayCtx = this.overlayCanvas.getContext('2d');
    //this.overlayCtx.clearRect(0, 0, window.innerWidth, window.innerHeight);
    this.overlayCtx.clearRect(0, 0, this.mapWidth, this.mapHeight);
    // this.overlayCtx.clearRect(0, 0, this.ctx.canvas.width / olHas.DEVICE_PIXEL_RATIO, this.ctx.canvas.height / olHas.DEVICE_PIXEL_RATIO);

  }

  private addOverlayCanvasMarker() {
    const viewportTop = this.olViewportElement.getBoundingClientRect().top;
    //background
    this.overlayCtx.clearRect(0, 0, this.mapWidth + 366, this.mapHeight + this.safeTop + 250);
    // this.overlayCtx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height / olHas.DEVICE_PIXEL_RATIO);
    this.overlayCtx.fillStyle = 'rgba(51, 51, 51, 0.2)';
    this.overlayCtx.fillRect(0, 0, this.mapWidth + 366, this.mapHeight + this.safeTop + 250); //250: give a bit space for open elevation profle
    // this.overlayCtx.fillRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height / olHas.DEVICE_PIXEL_RATIO);
    this.overlayCtx.fill();
    //circle (x,y,r,sAngle,eAngle,counterclockwise);
    this.overlayCtx.strokeStyle = 'rgba(224, 190, 12, 1)';
    this.overlayCtx.fillStyle = 'rgba(224, 190, 12, 0.3)';
    this.overlayCtx.lineWidth = 2;
    this.overlayCtx.beginPath();
    this.overlayCtx.arc(this.mapWidth / 2, (this.mapHeight / 2) + viewportTop, 12, 0, 2 * Math.PI);
    this.overlayCtx.stroke();
    this.overlayCtx.fill();
    //marker symbol 
    this.overlayCtx.fillStyle = 'rgba(241, 91, 2, 1.0)';
    this.overlayCtx.font = '32px "NGI-IGN_ICONS"';
    this.overlayCtx.strokeStyle = 'rgba(255, 255, 255, 1)';
    this.overlayCtx.lineWidth = 5;
    this.overlayCtx.strokeText(String.fromCharCode(0xe062), (this.mapWidth / 2) - 16, (this.mapHeight / 2) - 9 + viewportTop);
    this.overlayCtx.fillText(String.fromCharCode(0xe062), (this.mapWidth / 2) - 16, (this.mapHeight / 2) - 9 + viewportTop);
    this.overlayCtx.save();
    //!chrome ruins the canvas lay-out on resize, so:
    // window.addEventListener('resize', () => this.redraw());
  }
  // private redraw() {
  //   if (this.overlayCanvas) {
  //     this.overlayCanvas.remove();
  //   };
  //   setTimeout(() => {
  //     if (!document.getElementById('overlayCanvas')) {
  //       this.createOverlayCanvas();
  //       if (this.toolTip.placeMarkerTouch) {
  //         this.addOverlayCanvasMarker();
  //       }
  //       if (this.toolTip.lockMarkerTouch || this.toolTip.readyToSend) {
  //         this.lockOverlayCanvasMarker();
  //       }
  //     }
  //   }, 0);
  // }


  private setMarkerStyles() {
    //var ctx = document.getElementsByTagName('canvas')[0].getContext('2d');
    //var context = canvas.getContext('2d');
    //ctx.font = '50px "NGI-IGN_ICONS"';
    let movePointStyle: Style = new Style({
      image: new Circle({
        radius: 14,
        fill: new Fill({
          color: [224, 190, 12, 0.3]
        }),
        stroke: new Stroke({
          color: [224, 190, 12, 1.0],
          width: 1
        })
      }),
      text:
        new Text({
          font: '32px "NGI-IGN_ICONS"',
          text: String.fromCharCode(0xe062), //"⭓", //ue058, //charCode
          textAlign: 'center',
          offsetY: -20,
          fill: new Fill({
            color: [241, 91, 2, 1.0]
          }),
          stroke: new Stroke({
            color: [255, 255, 255, 1.0],
            width: 4
          })
        }),
    });

    let placedPointStyle: Style = new Style({
      image: new Circle({
        radius: 14,
        fill: new Fill({
          color: [224, 190, 12, 0.3]
        }),
        stroke: new Stroke({
          color: [224, 190, 12, 1.0],
          width: 1
        })
      })
      ,
      text: new Text({
        font: '28px "NGI-IGN_ICONS"', //ctx.font,
        text: String.fromCharCode(0xe062), //ue058////u2c4c
        textAlign: 'center',
        offsetY: -20,
        fill: new Fill({
          color: [32, 219, 2, 1.0]
        }),
        stroke: new Stroke({
          color: [255, 255, 255, 1.0],
          width: 4
        })
      })
      //,zIndex: 9
    });
    let lockedPointStyle: Style = new Style({
      image: new Circle({
        radius: 12,
        fill: new Fill({
          color: [224, 190, 12, 0.2]
        }),
        stroke: new Stroke({
          color: [224, 190, 12, 1.0],
          width: 1
        })
      }),
      text: new Text({
        font: '30px "NGI-IGN_ICONS"', //ctx.font,
        text: String.fromCharCode(0xe062), //ue058////u2c4c
        textAlign: 'center',
        offsetY: -20,
        fill: new Fill({
          color: [0, 25, 214, 1.0]
        }),
        stroke: new Stroke({
          color: [255, 255, 255, 1.0],
          width: 4
        })
      })
    });
    this.styles.set('movePointStyle', movePointStyle);
    this.styles.set('placedPointStyle', placedPointStyle);
    this.styles.set('lockedPointStyle', lockedPointStyle);

  }

  private setToolTip(type: string) {
    Object.keys(this.toolTip).forEach(key => {
      if (type === key) {
        this.toolTip[key] = true;
      } else {
        this.toolTip[key] = false;
      }
    })
  }

  private refresh(): void {
    // without this magic call :-), nothing changes properly
    this.changeDetectorRef.detectChanges();
  }

  private setFullscreen() {
    const elm = document.querySelector<HTMLElement>('.remark-bottomsheet')!;
    //elm.style.maxHeight = '100vh';
    elm.style.minHeight = '100vh';


  }

  private unSetFullscreen() {
    const elm = document.querySelector<HTMLElement>('.remark-bottomsheet')!;
    //elm.style.maxHeight = '';
    elm.style.minHeight = '';
  }

}